@use "styles" as *;

.me-header {
  display: block;

  @include hide-on-print;
}
